import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getEnquiriesApi } from '../api/allApi';

export const fetchEnquiries = createAsyncThunk(
    'enquiries/fetchEnquiries',
    async (params, { rejectWithValue }) => {
        try {
            return await getEnquiriesApi(params);
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || 'Failed to fetch enquiries');
        }
    }
);

const enquiriesSlice = createSlice({
    name: 'enquiries',
    initialState: { data: null, fetchLoading: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchEnquiries.pending, (state) => {
                state.fetchLoading = true;
                state.error = null;
            })
            .addCase(fetchEnquiries.fulfilled, (state, action) => {
                state.fetchLoading = false;
                state.data = action.payload;
            })
            .addCase(fetchEnquiries.rejected, (state, action) => {
                state.fetchLoading = false;
                state.error = action.payload;
            });
    },
});

export default enquiriesSlice.reducer;